










import {Component, Prop, Vue } from 'vue-property-decorator';

import {Element} from "@api/models/Element";
import { EventInterface } from '../../types/EventInterface';
import { getImageUrl } from '@common/ImageUrlHelper';
import EventTitle from "../event-info/EventTitle.vue";
import PartnersList from "@share/common/partners-list/PartnersList.vue";

@Component({
    components: { EventTitle, PartnersList }
})
export default class EventPart extends Vue {
    @Prop() session: EventInterface;
    @Prop({ default: []}) partners: Element[]
    @Prop({required: true}) eventId: string;

    get backgroundImageUrl(): string {
        const stageFileId = this.$store.getters['events/selectedEvent']?.stageFileId;

        return getImageUrl(this.$route.params.backend, stageFileId, 1980);
    }
}

